import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useLanguage } from '../../contexts/LanguageContext';
import { unsubscribeByToken } from '../../services/communityService';
import './Community.css';

const CommunityUnsubscribePage = () => {
  const { t } = useTranslation('community');
  const { isRTL } = useLanguage();
  const { token } = useParams();
  const [loading, setLoading] = useState(true);
  const [success, setSuccess] = useState(false);

  useEffect(() => {
    let cancelled = false;

    const execute = async () => {
      try {
        setLoading(true);
        if (!token) {
          if (!cancelled) {
            setSuccess(false);
          }
          return;
        }
        await unsubscribeByToken(token);
        if (!cancelled) {
          setSuccess(true);
        }
      } catch (err) {
        console.error('Unsubscribe failed:', err);
        if (!cancelled) {
          setSuccess(false);
        }
      } finally {
        if (!cancelled) {
          setLoading(false);
        }
      }
    };

    execute();

    return () => {
      cancelled = true;
    };
  }, [token]);

  return (
    <div className="community-public-wrap" dir={isRTL ? 'rtl' : 'ltr'}>
      <div className="community-public-card">
        <h2 className="community-page-title" style={{ fontSize: 24 }}>{t('unsubscribe.title')}</h2>
        {loading ? (
          <p className="community-skeleton" style={{ marginTop: 10 }}>{t('viewer.loading')}</p>
        ) : success ? (
          <div className="community-message success">{t('unsubscribe.success')}</div>
        ) : (
          <div className="community-message error">{t('unsubscribe.invalid')}</div>
        )}
      </div>
    </div>
  );
};

export default CommunityUnsubscribePage;
